import styled from '@emotion/styled'
import { Box } from '@mui/material'
import { exportToPPT_tableCss } from '../../../../util'

export const RowWrap = styled(Box)(`
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
`)

export const HeadingWrap = styled(Box)(`
    display: flex;
    align-items: center;
    margin-right: auto;
    & .rowHeading {
        font-size: 20px;
        font-weight: 400; // 300;
    }
    & .toolTipButtonIconWrap{
        margin-top: -15px;
    }
`)

export const RootWrap = styled(Box)(`
    width:100%;
    
    .campaignTriggersRow.tableWrap .showToolTip:before{z-index:4;}

    &.exportToPPT {
        max-width:1400px;
        // .pptSectionWrap{width:1400px; box-shadow:none; }

        .sectionWrap{width:1400px; box-shadow:none;}

        .pptSectionWrap{
            width:1400px; box-shadow:none; padding:0 !important; margin:0 !important; border:0 !important;

            &.campaignTriggersRowNewSlidePPT{padding-top:0 !important; }
        
            &.sectionWrap .titleForPPT{display:block; padding-top:0 !important;}
            &.tableWrap > div{margin:0; padding:15px 0 0 0;}
            &.tableWrap table{margin:0;}
            &.tableWrap table th{position:relative; padding:4px; }
            &.tableWrap table th .table-head-cell-html{padding:4px; font-size: 11px; line-height: 13px;}
            &.tableWrap table td{position:relative; padding:8px; font-size:12px !important;}
            &.tableWrap table td .campaignMagnetScore{padding:0;}
            &.tableWrap table td .campaignMagnetScore .barSliceWrap .barSlice{height:20px !important;}
            &.tableWrap table td .campaignMagnetScore .barSliceWrap .barSliceLabel{ margin: 0; height: 20px; line-height: 20px; top: 20px; left: 0;}
            &.tableWrap table td .campaignMagnetScore .barRoot{background: transparent;}
            &.tableWrap table td .campaignMagnetScore .barSliceBottom{font-size:12px;}
            &.tableWrap table td button{display:none;}
            &.tableWrap .triggerName{align-items: start;}
            
            &.sectionWrap{margin:0; border:0; padding-top:0;}
            &.sectionWrap p{margin-bottom:0;}
            &.sectionWrap .campaignMagnetScore{padding:4px 0; margin-left:220px;}
            &.sectionWrap .campaignMagnetScore .barSliceWrap .barSlice{height:26px !important;}
            &.sectionWrap .campaignMagnetScore .barRoot{height:26px; overflow:hidden;}
            &.sectionWrap .campaignMagnetScore > p{max-width:220px; left:-228px;}
            &.sectionWrap .barGridItem{padding:0;}
            &.sectionWrap .barGridItem p{padding:0; margin:0;}
            &.sectionWrap button{display:none;}
            // .headerTitle{font-size:0 !important}
            .campaignMagnetScore .barSliceEndIcon img{width:15px;}
            &.headerWrap p{padding:0 0 5px 0; line-height:1; }
            &.headerWrap{border-right:10px #fff solid;}
            &.headerWrap button{display:none;}
            &.headerWrap .titleForPPT{display:block;}
            .SubTriggers {padding-top:30px !important; 
                font-weight: 600; // 500;
            }
            &.ImpactBrandPerception {padding-top:30px; 
                font-weight: 600; // 500;
            }
            .campaignTriggersRow * {font-size:14px !important; 
                font-weight: 600; // 500;
            }
        }

        .graphWrapper.campaignTriggersRow {
            height: 40px;
            .campaignMagnetScore {padding:0 50% 0 0 !important; margin:4px 0; height:26px; margin-left:220px;}
            .campaignMagnetScore .barSliceWrap{margin-top:6px !important;}
            .campaignMagnetScore .barSliceWrap .barSlice{height:26px !important;}
            .campaignMagnetScore > p{max-width:220px; left:-228px;}
            button{ display:none; }
        }
        .campaignTriggersRow.pageBreakerForPPT{display:block !important;}

        .campaignTriggersRow.pageBreakerForPPT:last-child{display:none;}
    }
    ${exportToPPT_tableCss}
`)
